import careConfig from './config/health/care';
import truckConfig from './config/logistics/truck';
import gastroConfig from './config/service/gastro';
import schedulerConfig from './config/logistics/scheduler';
var configs = {
  A: {
    care: careConfig,
    truck: truckConfig,
    'service-gastro': gastroConfig,
    'logistics-scheduler': schedulerConfig
  },
  B: {
    truck: truckConfig,
    'service-gastro': gastroConfig,
    'logistics-scheduler': schedulerConfig,
    // default config for B variant
    care: careConfig
  }
};
export default (function (discriminator) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'A';
  return function (target) {
    return configs[variant][discriminator][target];
  };
});